import type { WhatsNewBody } from '../types';

export default {
  title: 'Change orders now move from PCO to COR to OCO',
  summary:
    'A change is now one record that moves through three stages: a PCO when it is opened, a COR once it is sent to the client, and an OCO once the client accepts it. A change that sits in a stage for a week is flagged, so nothing goes quiet.',
  details: [
    'On a job, open the Change Mgmt tab: + New PCO, then Sent to client…, then Client accepted…. The old Approve and Reject buttons are gone.',
    'The accepted date is the day the client accepted, not the day it was clicked. Correct date… fixes it until the change is linked to Sage.',
    'After the overnight sync, Link to Sage… saves Intacct’s amount as the amount that counts. A later change in Intacct is flagged, and only moves if you click Take Sage’s amount….',
    'A stalled change shows an amber line on its row, in the Needs attention tile, and on Today.',
  ],
  audience: { label: 'project managers and engineers', test: (a) => a.editsProjects },
  tryIt: { to: '/projects', label: 'Open Projects' },
  image: {
    file: 'change-order-stages.png',
    alt: 'The Change Orders table on a job, with three example changes shown as PCO Potential, COR With the client and OCO Accepted, each with its next-step buttons.',
  },
  guide: { topic: 'mod-changes-stages' },
} satisfies WhatsNewBody;
